import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import "../../style.css";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";
import { ChartBar } from "./chart";
import { TableList } from "./table";

interface Info {
  type: string
}
export interface Routes {
  data: {
    delays: {
      today_delay: number
      today_on_time: number
      last_weeks_delay_avg: number
      last_weeks_on_time_avg: number
      last_weekday_delay_avg: number
      last_weekday_on_time_avg: number
      region?: string
    }[],
    count: number,
    total: {
        today_delay: number,
        today_on_time: number,
        last_weeks_delay_avg: number,
        last_weeks_on_time_avg: number,
        last_weekday_delay_avg: number,
        last_weekday_on_time_avg: number
    }
  }
}

export const RoutesBeginDelays = ({type}: Info) => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent } = useContext(DashboardContext);
  const { shortToken , id, mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);

  let routeRoutes: string;
  const [routes, setRoutes] = useState<Routes["data"]>({
    delays: [{ today_delay: 0, today_on_time: 0, last_weeks_delay_avg: 0, last_weeks_on_time_avg: 0, last_weekday_delay_avg: 0, last_weekday_on_time_avg: 0, region: "" }],
    count: 0,
    total: {today_delay: 0, today_on_time: 0, last_weeks_delay_avg: 0, last_weeks_on_time_avg: 0, last_weekday_delay_avg: 0, last_weekday_on_time_avg: 0}
  });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeRoutes = `/routes/begin-delays?graphic_id=chartRoutesBeginDelays&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeRoutes = `/routes/begin-delays?graphic_id=chartRoutesBeginDelays&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeRoutes)
      .then((routes: Routes) => {
        setRoutes(routes.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    type === 'chart' ? (
      <div id="chart-routes-begin-delays" className="h100">
        <ChartBar data={routes} />
      </div>
    ) : (
      <div id="table-routes-begin-delays" className="h100">
        <TableList data={routes} />
      </div>
    )
  ) : (
    <LoadingGraphics/>
  );
};
